import { h, Component } from 'preact';
import * as Validators from '../../../../utils/forms/validators';
import { Form } from '../../../../utils/forms/form';

interface ListingEditorErrorMessageProps {
  form: Form;
  fieldName: any;
  message: String;
}

interface ListingEditorErrorMessageState {}

export class ListingEditorErrorMessage extends Component<ListingEditorErrorMessageProps, ListingEditorErrorMessageState> {

  render() {

    const { form, fieldName, message } = this.props;

    if (Validators.cxValidateField(form.fields[fieldName])) {
      return (
        <div className="hi-error-help-text">
          <i className="fas fa-exclamation-circle"></i> { message }
        </div>
      );
    }
  }


}